// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.bsh[data-v-3a382d93] {\n  box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.1), 0 0 2px 0 rgba(55, 71, 79, 0.2);\n  border-radius: 4px;\n}\n.minisite__button[data-v-3a382d93] {\n  padding: 14px 15px;\n  line-height: 1.43;\n  border: none;\n  border-bottom: 1px solid #edf0f1;\n  box-shadow: none;\n  justify-content: space-between;\n}\n.minisite__button__nptb[data-v-3a382d93] {\n  cursor: initial;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n", ""]);
// Exports
module.exports = exports;
